<div class="p-8">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="lab-mng">
        Manage Organization
    </div>
    <div class="box">
        <div class="relative w-full btn-1 my-6">
            <label class="flex absolute inset-y-0  items-center pl-3 pointer-events-none">
                <svg aria-hidden="true" class="w-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                    viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
                        stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </label>
            <input type="text" id="simple-search" class="br-1 btn-1 border-gray-200 org-name block p-2.5"
                placeholder=" Search by Org Name/created By" style="padding-left: 35px;" (keyup)="applyFilter($event)"
                [formControl]="searchControl">
        </div>
        <div class="push my-6 mr-2">
            <select name="labNames" id="" class="btn-2 border-gray-200 rounded-lg mb-5 input-style org-name"
                (change)="onChangeOrgType($event)">
                <option value="" class="org-name">All Types</option>
                <ng-container>
                    <option *ngFor="let option of dropdownOptions" [value]="option">{{ option }}</option>
                </ng-container>
            </select>
            <select name="labNames" id="" class="btn-2 border-gray-200 rounded-lg mb-5 mx-2 input-style org-name"
                (change)="onChangeStatus($event)">
                <option value="" class="org-name">All Status</option>
                <ng-container>
                    <option *ngFor="let option of dropdownStatus" [value]="option">{{ option }}</option>
                </ng-container>
            </select>
            <!-- refer lablist page -->

            <!-- <select  name="labNames" id="" 
                class="btn-2 border-gray-200 rounded-lg mb-5 input-style org-name">
              <option value="" disabled selected></option>
            </select> -->
        </div>
        <div class="my-6 text-right" *ngIf="userPermissions.includes('create_organization')">
            <button class="btn-3 bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600"
                (click)="createOrg()">
                Create
            </button>
        </div>
    </div>
    <div class="min-h-screen flex">
        <div class="overflow-x-auto w-full">
            <div class="min-w-screen min-h-screen table-wrapper flex justify-center font-sans">
                <div class="w-full">
                    <div class="bg-white shadow-md rounded my-6">
                        <table
                            class="mx-auto max-w-full w-full whitespace-nowrap bg-white divide-y divide-gray-300 overflow-hidden">
                            <thead class="bg-greenish-blue text-white">
                                <tr class="text-white-600 uppercase text-sm leading-normal">
                                    <th class="text-left font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>
                                                Org Name
                                            </span>
                                        </div>
                                    </th>
                                    <th class="text-left font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>Org Type</span>
                                        </div>
                                    </th>
                                    <th class="text-center font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>
                                                Data Capture
                                            </span>
                                        </div>
                                    </th>
                                    <th class="text-center font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>
                                                Data Visualization
                                            </span>
                                        </div>
                                    </th>
                                    <th class="text-center font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>Created By</span>
                                        </div>
                                    </th>
                                    <th class="text-center font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>Created At</span>
                                        </div>
                                    </th>
                                    <th class="text-center font-semibold text-sm uppercase px-2 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>Status</span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                                <tr class="border-b border-gray-200 hover:bg-gray-100"
                                    *ngFor="let item of filteredOrganizations; let i = index">
                                    <td class="text-left  whitespace-nowrap py-3 px-2 cursor-pointer" [ngClass]="{disabled:!userPermissions.includes('edit_organization')}"
                                        (click)="userPermissions.includes('edit_organization') ? editOrg(item) :null" >
                                        <div class="font-bold">{{item.orgName}}</div>
                                    </td>
                                    <td class="text-left whitespace-nowrap py-3 px-2"
                                        [style.text-transform]='"uppercase"'>{{item.organizationType}}</td>
                                        <td class="text-center whitespace-nowrap py-3 px-2">
                                            <span *ngIf="item.isDataCaptureEnabled" class="green-tag" 
                                            (click)="dataCaptureEnabled(item)"
                                                style="padding: 5px 22px;">
                                                Enabled
                                            </span>
                                            <span *ngIf="!item.isDataCaptureEnabled" class="red-tag"  
                                            (click)="dataCaptureEnabled(item)">
                                                Disabled
                                            </span>
                                        </td>
                                        <td class="text-center whitespace-nowrap py-3 px-2">
                                            <span *ngIf="item.isDataVisualizationEnabled" class="green-tag" 
                                            (click)="dataVisualizationEnabled(item)"
                                                style="padding: 5px 22px;">
                                                Enabled
                                            </span>
                                            <span *ngIf="!item.isDataVisualizationEnabled" class="red-tag"  
                                            (click)="dataVisualizationEnabled(item)">
                                                Disabled
                                            </span>
                                        </td>
                                    <td class="text-center light-text">
                                        <div [class.non-clickable-link]="">{{item.createdBy}}</div>
                                    </td>
                                    <td class="text-center whitespace-nowrap py-3 px-2" title="dd/MM/yyyy hh:mm">
                                        {{item.createdAt | date:"dd/MM/yyyy" }}
                                        {{item.createdAt | date:"hh:mm a" }}
                                    </td>
                                    <td class="text-center whitespace-nowrap py-3 px-2">
                                        <span *ngIf="item.isActive" class="green-tag" 
                                        (click)="userPermissions.includes('edit_organization')?status(item):null" [ngClass]="{disabled:!userPermissions.includes('edit_organization')}"
                                            style="padding: 5px 22px;">
                                            Active
                                        </span>
                                        <span *ngIf="!item.isActive" class="red-tag"
                                        (click)="userPermissions.includes('edit_organization')?status(item):null" [ngClass]="{disabled:!userPermissions.includes('edit_organization')}">
                                            In Active
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>